import { render, staticRenderFns } from "./RappersPreloader.vue?vue&type=template&id=6557c99e&lang=pug&"
import script from "./RappersPreloader.vue?vue&type=script&lang=js&"
export * from "./RappersPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports